module.exports = __webpack_public_path__ + "media/5.6b36ee03.mp3";